// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"0":"226272fc7d89d55e120c","685":"9ad7864cbde60688c3ad","696":"e53612d3bc366f6f062a","766":"6a88a61c9b2e64cd5c45"}[chunkId] + ".chunk.js";
};